<template>
  <div>
    <h2 class="mb-4">
      <i class="fa-duotone fa-triangle-exclamation text-warning fa-fw"></i> {{ translate("alert") }}
    </h2>
    <div class="card">
      <div class="card-body">
        <HttpFormView :endpoint="utilities.path('admin/alert/global')" method="put" :content="{ value: info.global.alert }" @success="info.reload(); toasts.create({ color: 'success', content: translate('operation_successful') })">
          <template v-slot:form="{ content, errors, submit, loading }">
            <RichTextInputView v-model:value="content.value" :features="features" :errors="errors.value ? Array.isArray(errors.value) ? errors.value : [translate('richText.format.invalid')] : undefined"/>
            <div class="mt-3 d-flex justify-content-between">
              <ButtonView type="normal" color="primary" @click="submit">
                {{ translate("submit") }}
              </ButtonView>
              <HttpFormView v-if="info.global.alert" method="delete" :endpoint="utilities.path('admin/alert/global')" @success="info.reload()">
                <template v-slot:form="{ submit: submitDelete, loadingDelete }">
                  <ButtonView type="normal" color="danger" @click="submitDelete">
                    {{ translate('delete') }}
                  </ButtonView>
                  <SpinnerView color="danger" :active="loadingDelete"/>
                </template>
              </HttpFormView>
              <SpinnerView color="primary" :active="loading"/>
            </div>
          </template>
        </HttpFormView>
      </div>
    </div>
  </div>
</template>

<script>
import {
  HttpFormView,
  ButtonView,
  utilities,
  richTextFeatures,
  RichTextInputView,
  SpinnerView,
  toasts
} from "@niftybit/vue";
import info from "@/info";

export default {
  name: "EditGlobalAlertView",
  components: {SpinnerView, ButtonView, HttpFormView, RichTextInputView},
  computed: {
    toasts() {
      return toasts
    },
    utilities() {
      return utilities
    },
    info() {
      return info
    },
    features() {
      return [
        richTextFeatures.paragraph.create(),
        richTextFeatures.text.create(),
        richTextFeatures.hardBreak.create(),
        richTextFeatures.heading.create(),
        richTextFeatures.textStyle.create(),
        richTextFeatures.codeBlock.create(),
        richTextFeatures.bulletList.create(),
        richTextFeatures.orderedList.create(),
        richTextFeatures.infoBox.create(),
        richTextFeatures.blockQuote.create(),
        richTextFeatures.textAlign.create(),
        richTextFeatures.code.create(),
        richTextFeatures.strikethrough.create(),
        richTextFeatures.bold.create(),
        richTextFeatures.underline.create(),
        richTextFeatures.italic.create(),
        richTextFeatures.link.create(),
        richTextFeatures.videoEmbed.create(),
      ];
    }
  }
}
</script>